import script from "D:\\Games\\van\\van3\\App.vue?type=script"
export * from "D:\\Games\\van\\van3\\App.vue?type=script"
export default script